import {
  TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
} from '@/configuration/tiers/tiersConf';

export default function genererCritereRecherche() {
  return {
    auto: null,
    archive: false,
    email: null,
    telephone: null,
    compteComptable: null,
    motifsBlocagesId: [],
    blocageReglement: null,
    villes: [],
    tiers: [],
    sousType: [
      TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
    ],
  };
}

export function genererCritereRechercheProduit() {
  return {
    auto: '',
    categorie: [],
    actif: true,
    societeId: null,
    sansProduitMateriel: true,
    agencesId: [],
    avecLiaisons: null,
  };
}
